import axios from "axios";
import axiosRetry from "axios-retry";

import type { HTTPClientConfig } from "@app/lib/http-clients/http-client-types";

import { retryCondition } from "./helper";
import sentry from "../../services/sentry-facade";

/**
 * Add retry config to axios
 * Set the number of retry to 0 to avoid adding retry on all requests.
 * The retry configuration is set at the request level.
 */
axiosRetry(axios, {
  retries: 0,
  shouldResetTimeout: true,
  retryCondition: err => {
    const should_retry = err.isAxiosError && retryCondition(err);

    sentry.addBreadcrumb({
      message: err.message,
      category: "axios retry",
      level: "warning",
      data: err
    });

    return should_retry;
  },
  retryDelay: axiosRetry.exponentialDelay
});

export function axiosBrowser(config: HTTPClientConfig) {
  const cancel_fn = config.cancel;
  if (cancel_fn) {
    config.cancelToken = new axios.CancelToken(c => cancel_fn(c));
  }

  return axios(config).then(res => ({
    body: res.data,
    headers: res.headers,
    status_code: res.status
  }));
}
